import styled from 'styled-components';
import { ThemeColours } from '../../../../../common/styles/ThemeColours';
import { Breakpoint, FONT_STACK } from '../../../../../common/styles/constants';

export const CARD_SECTION_INDENT = 8;

export const CARD_SECTION_OUTDENT = -CARD_SECTION_INDENT;

export const Card = styled.li.attrs({ 'data-testid': 'Card' })`
  ${FONT_STACK};
  background-color: ${ThemeColours.white};
  border: solid 1px ${ThemeColours.mono200};
  border-radius: 4px;
  box-sizing: border-box;
  display: block;
  margin-bottom: 8px;
  position: relative;
  text-decoration: none;
  width: 100%;

  &:hover {
    box-shadow: 0 1px 10px 0 rgba(92, 119, 131, 0.3);
  }
`;

export const Spacer = styled.div`
  margin-bottom: 8px;
`;

export const CardBody = styled.div`
  padding: 12px 16px 12px 16px;
  position: relative;

  ${Breakpoint.SMALL} {
    padding: 16px 24px 16px 24px;
  }
`;

export const CardSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${CARD_SECTION_INDENT}px;
`;

export const CardLeftColumn = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  margin-inline-end: 0px;
  min-width: 0;
`;

export const PracticeDetailsSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PracticeDetailsWrapper = styled(CardLeftColumn)`
  margin-inline-end: 0px;
`;

export const CardRightColumn = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`;

export const LogoFrame = styled.div`
  align-items: center;
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  height: 64px;
  padding: 4px;
  width: 80px;

  ${Breakpoint.SMALL} {
    height: 80px;
    width: 133px;
  }
`;

export const ImageContainer = styled.div`
  align-items: center;
`;
